import { z } from 'zod';

export const moduleDocAiSchema = z.object({
  userType: z.string().min(1, 'Please select a user type'),
  appType: z.string().min(1, 'Please select an app type'),
  fileStorageId: z.string().min(1, 'Please upload a document'),
  moduleName: z.string().min(1, 'Module Name is required'),
  moduleCode: z.string().min(1, 'Module Code is required'),
});

export type ModuleDocAiSchema = z.infer<typeof moduleDocAiSchema>;
